import { render, staticRenderFns } from "./kadru.vue?vue&type=template&id=337e3c4e&scoped=true&"
import script from "./kadru.vue?vue&type=script&lang=js&"
export * from "./kadru.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337e3c4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('337e3c4e')) {
      api.createRecord('337e3c4e', component.options)
    } else {
      api.reload('337e3c4e', component.options)
    }
    module.hot.accept("./kadru.vue?vue&type=template&id=337e3c4e&scoped=true&", function () {
      api.rerender('337e3c4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/create/mem_preview/addon/kadru/kadru.vue"
export default component.exports